function initQuantityScript() {
  const interval = setInterval(() => {
    const quantityInput = document.querySelector('input[name="quantity"]');
    const priceElement = document.querySelector("[data-product-price]");

    if (quantityInput && !document.querySelector(".quantity-wrapper-custom")) {
      clearInterval(interval);

      quantityInput.style.display = "none";

      const wrapper = document.createElement("div");
      wrapper.classList.add("quantity-wrapper-custom");
      wrapper.style.display = "flex";
      wrapper.style.alignItems = "center";
      wrapper.style.justifyContent = "flex-start"; // выравниваем по левому краю
      wrapper.style.gap = "8px"; // делаем кнопки ближе друг к другу
      wrapper.style.marginTop = "12px";
      wrapper.style.flexWrap = "wrap";
      wrapper.style.width = "100%";

      // универсальная функция создания кнопки
      const createButton = (text) => {
        const btn = document.createElement("button");
        btn.innerText = text;
        btn.type = "button";
        btn.style.width = "36px";
        btn.style.height = "36px";
        btn.style.border = "1px solid black";
        btn.style.background = "white";
        btn.style.cursor = "pointer";
        btn.style.fontSize = "20px";
        btn.style.borderRadius = "50%";
        btn.style.transition = "background 0.2s, transform 0.1s";

        // эффект нажатия
        btn.addEventListener("mousedown", () => {
          btn.style.background = "#f0f0f0";
          btn.style.transform = "scale(0.96)";
        });
        btn.addEventListener("mouseup", () => {
          btn.style.background = "white";
          btn.style.transform = "scale(1)";
        });
        btn.addEventListener("mouseleave", () => {
          btn.style.background = "white";
          btn.style.transform = "scale(1)";
        });

        return btn;
      };

      const minusBtn = createButton("–");
      const plusBtn = createButton("+");

      const display = document.createElement("span");
      display.innerText = quantityInput.value;
      display.style.fontSize = "18px";
      display.style.minWidth = "30px";
      display.style.textAlign = "center";

      wrapper.appendChild(minusBtn);
      wrapper.appendChild(display);
      wrapper.appendChild(plusBtn);

      quantityInput.parentNode.insertBefore(wrapper, quantityInput.nextSibling);

      let basePrice = 0;
      if (priceElement) {
        const priceText = priceElement.innerText
          .replace(/[^\d,]/g, "")
          .replace(",", ".");
        basePrice = parseFloat(priceText);
      }

      const update = () => {
        const value = parseInt(quantityInput.value);
        display.innerText = value;

        if (priceElement && basePrice > 0) {
          const total = (basePrice * value).toFixed(2).replace(".", ",");
          priceElement.innerText = `${total} zł`;
        }
      };

      plusBtn.addEventListener("click", () => {
        quantityInput.value = parseInt(quantityInput.value) + 1;
        quantityInput.dispatchEvent(new Event("change"));
        update();
      });

      minusBtn.addEventListener("click", () => {
        const current = parseInt(quantityInput.value);
        if (current > 1) {
          quantityInput.value = current - 1;
          quantityInput.dispatchEvent(new Event("change"));
          update();
        }
      });

      quantityInput.addEventListener("change", update);
      update();
    }
  }, 300); // ждём появления поля количества
}

// запускаем на все типы загрузки Shopify
document.addEventListener("DOMContentLoaded", initQuantityScript);
document.addEventListener("shopify:section:load", initQuantityScript);
document.addEventListener("shopify:section:select", initQuantityScript);

window.copyProductLink = function (button) {
  button.style.transform = "scale(0.9)";
  button.style.backgroundColor = "#f0f0f0";

  const svg = button.querySelector("svg");
  const originalSVG = svg.innerHTML;

  // Иконка галочки (✔)
  svg.innerHTML = `
    <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" fill="none"
      stroke-linecap="round" stroke-linejoin="round"/>
  `;

  setTimeout(() => {
    svg.innerHTML = originalSVG;
    button.style.transform = "scale(1)";
    button.style.backgroundColor = "transparent";
  }, 2000);

  navigator.clipboard.writeText(window.location.href).catch((err) => {
    console.error("Ошибка копирования:", err);
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const thumbs = document.querySelector(".product__thumbs");
  const info = document.querySelector(".product__info-wrapper"); // правая часть страницы

  if (!thumbs || !info) return;

  thumbs.addEventListener("mouseenter", () => {
    document.body.style.overflow = "hidden";
  });

  thumbs.addEventListener("mouseleave", () => {
    document.body.style.overflow = "auto";
  });

  // ВОТ ЭТО ДОБАВЛЯЕМ: когда курсор уходит на правую часть — восстанавливаем scroll
  info.addEventListener("mouseenter", () => {
    document.body.style.overflow = "auto";
  });
});
const gallery = document.querySelector(".product__photos");

if (gallery) {
  gallery.addEventListener("mouseenter", () => {
    document.body.classList.add("no-scroll");
  });

  gallery.addEventListener("mouseleave", () => {
    document.body.style.overflow = "auto";
  });
}

// Работа с фильтром
if (
  window.location.pathname === "/collections/akcesoria" ||
  window.location.pathname === "/collections/sprzet-sportowy"
) {
  const sizeFilter = document.querySelector(".collection-filter__group--2");
  if (sizeFilter) {
    sizeFilter.style.display = "none";
  }
}

// Порядок фильтров от xs до
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    function sortFilters(filterGroup, sizeOrder) {
      var filterList = filterGroup.querySelector(".tag-list");

      if (!filterList) return;

      var sizeFilters = Array.from(filterList.querySelectorAll("li.tag"));

      sizeFilters.sort(function (a, b) {
        var sizeA = a.querySelector(".tag__text").textContent.trim();
        var sizeB = b.querySelector(".tag__text").textContent.trim();

        return sizeOrder.indexOf(sizeA) - sizeOrder.indexOf(sizeB);
      });

      sizeFilters.forEach(function (filter) {
        filterList.appendChild(filter);
      });
    }

    var filterGroups = document.querySelectorAll(".collection-filter__group");

    filterGroups.forEach(function (group) {
      if (group.classList.contains("collection-filter__group--2")) {
        var sizeOrder1 = [
          "XS (50-60 cm)",
          "S (65-70 cm)",
          "M (75-80 cm)",
          "L (85-90 cm)",
        ];
        sortFilters(group, sizeOrder1);
      } else if (group.classList.contains("collection-filter__group--2")) {
        var sizeOrder2 = [
          "XS (25x26cm)",
          "S (28x27 cm)",
          "M (31x29 cm)",
          "L (33x30 cm)",
          "XL (35x31 cm)",
        ];
        sortFilters(group, sizeOrder2);
      }
    });
  }, 100);
});

// Функция для получения уникальных значений размеров
function getUniqueSizes(sizes) {
  const uniqueSizes = [];
  sizes.forEach((size) => {
    if (!uniqueSizes.includes(size)) {
      uniqueSizes.push(size);
    }
  });
  return uniqueSizes;
}

// Подложка под бургер-меню
document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(
    ".site-nav__thumb-button.js-toggle-slide-nav"
  );
  const overlay = document.querySelector(".menu-overlay");

  if (toggleButton && overlay) {
    toggleButton.addEventListener("click", function () {
      overlay.classList.toggle("active");
    });
  }
});

// Галерея на десктопе
document.addEventListener("DOMContentLoaded", function () {
  const thumbnails = document.querySelectorAll(".product__thumb-item a");
  const mainImage = document.querySelector(".product__main-photos-wrapper img");

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function (e) {
      const largeImage = e.target.closest("a").href;
      mainImage.src = largeImage;
    });
  });
});

// // Добавление margin
document.addEventListener("DOMContentLoaded", function () {
  const mainContent = document.querySelector(".main-content");
  const stickyCart = document.getElementById("StickyCart");

  if (!mainContent || !stickyCart) return;

  function updateMainContentMargin() {
    if (stickyCart.classList.contains("sticky-cart--open")) {
      mainContent.classList.add("shifted");
    } else {
      mainContent.classList.remove("shifted");
    }
  }

  updateMainContentMargin();

  const observer = new MutationObserver(updateMainContentMargin);
  observer.observe(stickyCart, {
    attributes: true,
    attributeFilter: ["class"],
  });
});
